export default {
  // サーバーからトークンを取得
  login({ commit }, { credentials }) {
    const { username, password } = credentials

    const requestBody = {
      username,
      password,
      grant_type: 'password',
      client_id: 2,
      client_secret: process.env.MIX_OAUTH_CLIENT_SECRET,
    }

    return window.axios.post('/oauth/token', requestBody)
      .then(({ data }) => data.access_token)
      .then((token) => {
        // axiosのヘッダーを更新
        window.axios.defaults.headers.common.Authorization = `Bearer ${token}`

        commit('addToken', token)

        return token
      })
  },

  // サーバーで保存されているトークンを削除
  logout({ commit }) {
    return window.axios.delete('/api/token')
      .then((res) => {
        commit('removeToken')
        commit('updateAuth', {})

        return res
      })
  },

  // サーバー経由の認証チェック
  check({ commit }, { controller, action }) {
    return window.axios.get(`/api/user?controller=${controller}&action=${action}`)
      .then((res) => {
        commit('updateAuth', res.data)

        return res
      })
      .catch((err) => {
        if (err.response.status === 401) {
          commit('removeToken')
          commit('updateAuth', {})
        }

        throw err
      })
  },

  tokenLogin({ commit }, { token }) {
    commit('addToken', token)
  },
}
